






import { defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import ModalView from "@/components/ModalView";
import SelectUserTagsController from "@/components/SelectUserTagsController";

export default defineComponent({
  name: "SelectUserTagsModal",
  components: { ModalView, SelectUserTagsController },
  props: {
    value: { type: Boolean, required: true },
    title: { type: String, default: $t("Categories") },
    modal: { type: Boolean, default: false },
  },
});
